import React from "react";

// CSS
import * as styles from "./BodyMetabolism.module.css";

const CardsComponent = props => {
  return (
    <div className="row">
      {props.cardDetails.map((item, index) => {
        const isLast = index === props.cardDetails.length - 1;
        const colClass = `col-lg col-md ${isLast ? "col-12" : "col-6"}`;

        return (
          <div className={colClass} key={index}>
            <div className={styles.diabConsLp__bdyMetablsm__cards}>
              {item.imgSrc}
              <p>{item.text}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CardsComponent;
